const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVattenBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "vatten",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.43 153.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "bb8794f5-54cd-4bb0-9fe7-c26244e970d2",
    "data-name": "border",
    d: "M38,6.07c4.33-1.36,19.18-.3,26.77-4.77C70.41-2,77.13,3.34,81,6.07s8.33,14.62,4.73,20-3.17,14.77-3.17,14.77l4.17,1V76.64h9.49v29.52l-8.57.25v24.75h3v20H50.15L48.06,148s-10.31-1.26-13.26,1-15.42,5.95-21.26,4.42c-3.43-.9-8.95-9.44-10.07-12.14s-.92-21.79-.93-34S.25,84.22.25,81.66s1.53-22.45,2.29-27A41.91,41.91,0,0,1,13.05,34.05,170.2,170.2,0,0,0,26.84,17.42S33.67,7.42,38,6.07Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVattenBorder);
export default __webpack_public_path__ + "static/media/vatten-border.b8d0db6a8f890088ec22979be21a8fbc.svg";
export { ForwardRef as ReactComponent };